module.exports = __webpack_public_path__ + "img/styria-media-design.4e0ecd03.svg";